<div class="p-7 bg-lightest">
  <div class="flex md:inline">
    <div
      class="md:ml-10 md:inline"
      *ngIf="hasToken">
      <button
        pButton
        class="back-accueil font-app-medium"
        [routerLink]="[BACKBUTTON]">
        <i class="pi pi-arrow-left mr-4 text-lg"></i>
        <span class="md:inline hidden">{{ "regularisationSchedule.backButton" | translate }}</span>
      </button>
    </div>
    <div class="title">
      <h1
        [ngClass]="{ 'ml-[40px]': !hasToken, 'ml-[20px]': hasToken }"
        class="flex flex-row text-xl md:text-2xl font-app-bold mb-5 md:mb-10 md:ml-10 md:mt-5">
        {{ "regularisationSchedule.title" | translate }}
      </h1>
    </div>
  </div>
  <div class="card mx-auto w-full md:mb-40">
    <p-card>
      <ng-template
        pTemplate="header"
        class="p-card-header">
        <p class="font-app-black text-sm text-darkest">{{ "regularisationSchedule.text1" | translate }} {{ name }}</p>
        <p class="font-app-regular text-sm mt-5 text-darkest">
          {{ "regularisationSchedule.text2" | translate }}
          {{ productName }}
          {{ "regularisationSchedule.text3" | translate }}
          {{ numeroContrat }}
          {{ "regularisationSchedule.text4" | translate }}
        </p>
        <p class="flex justify-center mt-2 text-primary text-2xl font-app-bold">
          {{ amount | currency: "EUR" : "symbol" : "" : "fr" }}
        </p>
        <p class="font-app-regular text-sm mt-5 text-darkest">
          {{ "regularisationSchedule.detailAmount" | translate }}
        </p>
        <div>
          <ul>
            @for (receipt of receiptDetails; track receipt) {
              <li class="font-app-regular text-sm text-darkest ml-3">
                <span *ngIf="receipt.receiptType === 2; else simpleReceipt">
                  {{ "regularisationSchedule.text8" | translate }} :
                </span>
                <ng-template #simpleReceipt>
                  {{ "regularisationSchedule.receipt" | translate }}
                  {{ receipt.coverDate | date: "MMMM y" : "Europe/Paris" : "fr" }}
                  :
                </ng-template>
                {{ receipt.amount | currency: "EUR" : "symbol" : "" : "fr" }}
              </li>
            }
            <li
              class="font-app-regular text-sm text-darkest ml-3"
              *ngIf="feeAmount !== 0">
              {{ "regularisationSchedule.feeAmount" | translate }}
              {{ feeAmount | currency: "EUR" : "symbol" : "" : "fr" }}
            </li>
          </ul>
        </div>

        <p class="font-app-regular text-sm mt-5 text-darkest">
          {{ "regularisationSchedule.text5" | translate }}
          <span class="text-primary">{{ suspensionDate | date: "dd MMMM yyyy" : "Europe/Paris" : "fr" }}</span
          >.
        </p>
        <p class="font-app-regular text-sm mt-3 text-darkest">
          {{ "regularisationSchedule.text6" | translate }}
          <span class="text-primary">{{ terminationDate | date: "dd MMMM yyyy" : "Europe/Paris" : "fr" }}</span>
          {{ "regularisationSchedule.text7" | translate }}
        </p>
      </ng-template>
      <p-divider
        type="solid"
        class="-mt-12 block md:hidden"></p-divider>
      <ng-template pTemplate="body">
        <p class="font-app-black text-sm text-darkest">
          {{ "paymentForm.title" | translate }}
        </p>
        <br />
        <app-payment-form
          *ngIf="formToken"
          (paymentEvent)="paymentEvent($event)"
          (showPopup)="showPopup($event)"
          [formToken]="formToken"></app-payment-form>
      </ng-template>
    </p-card>
  </div>
</div>
<app-popup-events-payment
  *ngIf="showPopupPayment"
  [paymentSuccess]="paymentSuccess"
  [showPopupPayment]="showPopupPayment"
  [hasToken]="hasToken"
  [userEmail]="userEmail"
  [firstConnectionUrl]="firstConnectionUrl"
  [unpaidPolicy]="hasUnpaidReceipts"
  [advancePayment]="!hasUnpaidReceipts"
  (dialogEmitter)="showPopup($event)"></app-popup-events-payment>

